/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import { getIsAuth, getIsAuthPending } from 'redux/reducers/auth/selectors';
import queryString from 'query-string';
import {
	getOrganizationsRequest,
	getUserInfoRequest,
	setOrganization,
} from 'redux/reducers/user/reducer';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	MenuItem,
	Select,
	Typography,
} from '@mui/material';
import {
	getUserInfo,
	getUserInfoLoader,
	getUserOrganizations,
	getUserOrganizationsLoader,
} from 'redux/reducers/user/selectors';
import { EASSpinner } from 'components/EASSpinner';
import { getMerchantIdSuccess } from 'redux/reducers/auth/reducer';
import {
	getMonthlySalesInfoRequest,
	getSalesInfoRequest,
	getTotalTaxesRequest,
} from 'redux/reducers/dashboard/reducer';

export const SignIn: FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const ifAuth = useSelector(getIsAuth);
	const codeIsLoading = useSelector(getIsAuthPending);
	const userInfo = useSelector(getUserInfo);
	const userInfoLoading = useSelector(getUserInfoLoader);
	const organizations = useSelector(getUserOrganizations);
	const organizationsLoading = useSelector(getUserOrganizationsLoader);
	console.log('userInfo', userInfo);

	const [em, setEm] = useState(0);

	const handleEm = (e: any) => {
		setEm(e.target.value);
	};

	useEffect(() => {
		if (codeIsLoading) return;
		dispatch(getUserInfoRequest());
		dispatch(getOrganizationsRequest());
	}, [dispatch, codeIsLoading]);

	const handleButtonClick = () => {
		if (!em || !organizations?.rows[em - 1]?.group_id) return;
		dispatch(getMerchantIdSuccess({ xMerchantId: organizations?.rows[em - 1]?.group_id }));
		dispatch(getTotalTaxesRequest({ em_id: organizations?.rows[em - 1]?.id }));
		dispatch(getSalesInfoRequest({ em_id: organizations?.rows[em - 1]?.id }));
		dispatch(getMonthlySalesInfoRequest({ em_id: organizations?.rows[em - 1]?.id }));
		dispatch(setOrganization(organizations?.rows[em - 1]));

		navigate(`/monthly-fee`);
	};

	if (codeIsLoading || userInfoLoading || organizationsLoading) return <EASSpinner />;
	return (
		<div
			style={{
				display: 'flex',
				alignContent: 'center',
				justifyContent: 'center',
				height: '100vh',
				backgroundColor: '#f5f5f5',
				color: '#016193',
			}}
		>
			<Card
				sx={{
					width: 360,
					height: 470,
					textAlign: 'center',
					mt: '10vh',
					color: '#016193',
					position: 'relative',
				}}
			>
				<CardMedia sx={{ height: 140 }} image="/img/fon.png" />
				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						maxWidth: 360,

						// height: 'auto',
						padding: '34px 90px',
					}}
				>
					<img
						src="/img/EAS-project-logo.svg"
						alt=""
						style={{
							width: '100%',
						}}
					/>
				</div>
				<CardContent>
					<Typography gutterBottom variant="h5" component="h1">
						Welcome
					</Typography>
					<Typography gutterBottom variant="h4" component="h2">
						{userInfo?.fullName}
					</Typography>
					<hr style={{ border: '.2px solid  #016193', marginTop: '40px' }} />
					<Typography gutterBottom variant="subtitle2" component="div">
						Select the merchant interface to continue
					</Typography>
					<Select
						value={em}
						onChange={handleEm}
						displayEmpty
						inputProps={{ 'aria-label': 'Without label' }}
						sx={{ width: '300px' }}
					>
						{organizations?.rows.map((item, index) => (
							<MenuItem key={item.id} value={index + 1}>
								{item.group_name}
							</MenuItem>
						))}
					</Select>
					<Button
						disabled={!em}
						sx={{ width: '300px', marginTop: '30px' }}
						variant="contained"
						size="large"
						onClick={handleButtonClick}
					>
						Go to Portal
					</Button>
				</CardContent>
				{/* <CardActions>
				</CardActions> */}
				{/* <div>token: {token}</div> */}
			</Card>
		</div>
	);
};
